import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as AddPlus } from "../../assets/addPlus.svg";
import { ReactComponent as FacturaGPTSVG } from "../../assets/facturaGPTBlackIcon.svg";
import { ReactComponent as Star } from "../../assets/starPlus.svg";
import styles from "./NavbarAdmin.module.css";
// import { ReactComponent as AddPlusWhite } from "../../assets/addPlusWhite.svg";
import { ReactComponent as ChatIcon } from "../../assets/chatIcon.svg";
import { ReactComponent as DashboardBlackIcon } from "../../assets/DashboardBlackIcon.svg";
import { ReactComponent as DotsNotification } from "../../assets/dotsNotification.svg";
import { ReactComponent as GptsBlackIcon } from "../../assets/GptsBlackIcon.svg";
import { ReactComponent as LogoutBlackIcon } from "../../assets/LogoutBlackIcon.svg";
import { ReactComponent as SettingBlackIcon } from "../../assets/SettingBlackIcon.svg";
import { ReactComponent as StarPlus } from "../../assets/starPlus.svg";
// import { ReactComponent as PaperMicrophone } from "../../assets/paperMicrophone.svg";
import { ReactComponent as LunaDarkMode } from "../../assets/lunaDarkMode.svg";
import { ReactComponent as MenuMobileIcon } from "../../assets/menuIconBlack.svg";
// import { ReactComponent as VoiceIcon } from "../../assets/voiceIcon.svg";
import { ReactComponent as IconStar } from "../../assets/icon-star.svg";
import { ReactComponent as IconWorkspace } from "../../assets/icon-workspace.svg";
import { ReactComponent as IconNews } from "../../assets/icon-news.svg";

import { ReactComponent as IconClose } from "../../assets/icon-close.svg";

import { ReactComponent as IconSearch } from '../../assets/icon-search.svg';

import { menuOptions } from "./menuOptions.js";

import { setNotification } from "@src/actions/user";
import { MdLightMode } from "react-icons/md";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ReactComponent as BlackCircleChecked } from "../../assets/blackCircleChecked.svg";
import UpgradePlanWrapper from "../../screens/UpgradePlan/UpgradePlan";
import Automate from "../Automate/Automate";
import PanelAutomate from "../Automate/panelAutomate/PanelAutomate";
import ColorPicker from "../ColorPicker/ColorPicker";
import CorporativeModalText from "../CorporativeModalText/CorporativeModalText";
import CreateFolderModal from "../CreateFolderModal/CreateFolderModal";
import FloatingMenu from "../FloatingMenu/FloatingMenu";
import GeneralSettings from "../GeneralSettings/GeneralSettings";
import ModalBlackBgTemplate from "../ModalBlackBgTemplate/ModalBlackBgTemplate";
import NewAsset from "../NewAsset/NewAsset";
import NewBIll from "../NewBIll/NewBIll";
import NewContact from "../NewContact/NewContact";
import NewTag from "../NewTag/NewTag";
import Notification from "../Notification/Notification";
// import PopUpNews from "../PopUpNews/PopUpNews";
import SeeBill from "../Preview/SeeBill/SeeBill";
import SeeHistory from "../SeeHistory/SeeHistory";
import SelectCurrencyPopup from "../SelectCurrencyPopup/SelectCurrencyPopup";
import SelectLocation from "../SelectLocation/SelectLocation";
import MobileAsidebarNavigation from "./MobileAsidebarNavigation/MobileAsidebarNavigation";

import { deleteAutomation } from "../../../../actions/automate";
import { setTheme } from "../../../../slices/themeSlices";
import ConfirmationPopup from "../ConfirmationPopup/ConfirmationPopup";
import DeleteChatAgents from "../DeleteChatAgents/DeleteChatAgents";
// import ChatVoice from "./ChatVoice/ChatVoice";
// import VariableListModal from "../VariableListModal/VariableListModal";
import SelectAgentModal from "../../screens/ChatView/SelectAgentModal/SelectAgentModal";
import NewUserInformation from "../NewUserInformation/NewUserInformation";
import VariableModal from "../VariableModal/VariableModal";


import NavbarNews from "./NavbarNews";

import AddPaymethodPopup from "../AddPaymethodPopup/AddPaymethodPopup";
import TokenModal from "../GeneralSettings/components/ConnectedApps/tokenModal/tokenModal";
// import { reinitI18n } from "../../../../i18";
import ConfirmationWithPasswordPopup from "../ConfirmationWithPasswordPopup/ConfirmationWithPasswordPopup";
import InviteToWorkspace from "../NewWorkspace/InviteToWorkspace/InviteToWorkspace";
import NewWorkspace from "../NewWorkspace/NewWorkspace";
// import { apiUrl } from "../../../../apiBackend";
import { getAssetsStatusViewed } from "../../../../actions/assets";
import { getAgentById } from "../../../../actions/chat";
import { getContactsStatusViewed } from "../../../../actions/contacts";
import { createVariable, getAllNotifications, getVariable, updateAccount } from "../../../../actions/user";
import AudioWaves from "../AudioWaves/AudioWaves";

import { setGlobalSearch, setShowModal} from "../../../../slices/userSlices";
import ExploreCommuniti from "../../screens/ChatView/ExploreCommuniti/ExploreCommuniti.jsx";


import MessageDoc from "../MessageDoc/MessageDoc";

// import { setShowModal } from "../../../../slices/userSlices";

const NavbarAdmin = ({ fromPath, setFromPath = () => { } }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { unseenCount } = useSelector((state) => state.notifications)
  // const { showModal } = useSelector((state) => state.user)

  const [themeStyles, setThemeStyles] = useState(
    document.documentElement?.getAttribute("data-theme")
  );
  const [selectedAgent, setSelectedAgent] = useState({});
  const [showSelectAgent, setShowSelectAgent] = useState(false);
  const [searchAutomate, setSearchAutomate] = useState();
  const [editingCurrency, setEditingCurrency] = useState(false);
  const [currentSetting, setCurrentSetting] = useState(null);
  const [showWorkspace, setShowWorkspace] = useState(false);
  const [showInviteToWorkspace, setShowInviteToWorkspace] = useState(false);
  // const [question,setQuestion] = useState('')
  const [userToInvite, setUserToInvite] = useState({
    mergePlanChecked: false,
  });
  const [showMergePlan, setShowMergePlan] = useState(false);
  const [hideAutomate, setHideAutomate] = useState(false);
  const [variant, setVariant] = useState('')
  const [roleAutomate, setRoleAutomate] = useState('input')
  const settingsOptions = [
    "general",
    "account",
    "devices",
    "speech",
    "team",
    "getPlus",
    "workspace",
    "dataControls",
    "connectedApps",
    "security",
  ];

  const { unseenCount: unseenCountContact } = useSelector((state) => state.contacts);
  const { unseenCount: unseenCountAsset } = useSelector((state) => state.assets);

  // const { unseenCount } = useSelector((state) => state.notifications)

  const [elapsedTime, setElapsedTime] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);





  const getAllNotificationsFn = async () => {
    const response = await dispatch(
      getAllNotifications({
        search: '',
        limit: 100,
        skip: 0,

      })
    );

    await dispatch(getContactsStatusViewed({}))
    await dispatch(getAssetsStatusViewed({}))
  };
  useEffect(() => {
    getAllNotificationsFn();
  }, [location?.pathname]);


  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    if (hours > 0) {
      return `${hours}h${minutes.toString().padStart(2, '0')}m`;
    } else if (minutes > 0) {
      return `${minutes}m${secs.toString().padStart(2, '0')}s`;
    } else {
      return `${secs}s`;
    }
  };

  useEffect(() => {
    const updateTimer = () => {
      const startTime = localStorage.getItem('startTime');
      const baseTime = parseInt(localStorage.getItem('baseTime') || '0');
      const isStopped = localStorage.getItem('isStopped') === 'true';

      if (isStopped) {
        setElapsedTime(0);
        setIsPlaying(false);
        return;
      }

      if (!startTime && baseTime > 0) {
        setElapsedTime(baseTime);
        setIsPlaying(false);
      } else if (startTime) {
        const now = Date.now();
        const currentSessionTime = Math.floor((now - parseInt(startTime)) / 1000);
        setElapsedTime(baseTime + currentSessionTime);
        setIsPlaying(true);
      }
    };

    updateTimer();

    const intervalId = setInterval(updateTimer, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const checkMergedPlan = () => {
    setUserToInvite((prev) => ({
      ...prev,
      mergePlanChecked: true,
    }));
  };

  useEffect(() => {
    const translation = localStorage.getItem("translationId");
    setVariant(translation ? translation : 'Factura')

    setThemeStyles(document.documentElement?.getAttribute("data-theme"));
  
  
  
  }, []);

  useEffect(() => {
    const currentPath = location.pathname;

    if (currentPath.includes("settings")) {
      const lastSegment = currentPath.split("/").filter(Boolean).pop();

      const matchedOption = settingsOptions.find(
        (option) => option === lastSegment
      );
      setCurrentSetting(matchedOption || null);
      // setShowSidebar(true); // This line was removed as per the new_code
    } else if(location.pathname.includes('news')){
      // setCurrentSetting(null); // This line was removed as per the new_code
    }else {
      setCurrentSetting(null);
    }


    // if(location.pathname.includes('news')){
    //   // dispatch(setShowModal('news'))
    // }
  }, [location]);







  const addFilterPath = (nuevoFiltro) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("automation", nuevoFiltro);

    navigate(
      {
        pathname: location.pathname,
        search: `?${searchParams.toString()}`,
      },
      { replace: true }
    );
  };

  useEffect(() => {
    if (location.search) {
      if (location.search.includes("automation")) {
        const searchParams = new URLSearchParams(location.search);
        const valorOriginal = decodeURIComponent(
          searchParams.get("automation") || ""
        );

        setSearchAutomate(valorOriginal);
        setTimeout(() => {
          dispatch(setShowModal('automate'))
          // addFilterPath(valorOriginal);
        }, 0);
      }
    }
  }, [location.search]);

  useEffect(() => {
    let path = location.pathname.split("/");
    // console.log('pa667777!', path)


    if (path[3] == 'settings') {
      dispatch(setShowModal('settings'))
      // switch(path[4]){
      //   case 'general':
      //     dispatch(setShowModal('settings'))
      //     break;
      //   case 'account':
      //     dispatch(setShowModal('account'))
      //     break;
      // }
    }


    // if (path?.length == 3) {
    //   console.log('path!!!!!!!1!', path)
    //   dispatch(setShowModal('marketplace'))
    //   // dispatch(setFatherNewAgent(path[2]));
    // } else if (path?.length == 4) {
    //   console.log('ppppppp!!!!!!!1!', path)
    //   dispatch(setShowModal('marketplace'))
    //   // dispatch(setFatherNewAgent(path[2]));
    //   path[3] !== "undefined" && dispatch(setIdFatherNewAgent(path[3]));
    // }
  }, [location.pathname]);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const automationId = searchParams.get("automation");

    if (automationId) {
      setIsModalAutomate(true);
      setSelectedAutomationData({
        id: automationId,
      });
    }
  }, []);

  const [seeHistory, setSeeHistory] = useState(false);

  const { showModal, paramModal, user, showNotification, showAutomation, isWorkBackend, 
    typeContentAutomateSlice, selectedAutomationDataSlice, roleAutomateSlice ,selectedAutomateToDeleteSlice} = useSelector(
    (state) => state.user,
    shallowEqual
  );

  const { theme } = useSelector((state) => state.theme);
  const { t } = useTranslation("navbarAdmin");

  const [isModalAutomate, setIsModalAutomate] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [showCreateFolder, setShowCreateFolder] = useState(false);
  const [showLocationModal, setShowLocationModal] = useState(false);

  const [typeVariableModal, setTypeVariableModal] = useState("category");
  const [showVariableListModal, setShowVariableListModal] = useState(false);
  const [showVariableModal, setShowVariableModal] = useState(false);

  const [showNewTagModal, setShowNewTagModal] = useState(false);
  const [showNewContact, setShowNewContact] = useState(false);
  const [showNewProduct, setShowNewProduct] = useState(false);
  const [showNewBill, setShowNewBill] = useState(false);
  const [selectedAutomationData, setSelectedAutomationData] = useState(null);
  const [seeBill, setSeeBill] = useState(false);

  const [showPlusModal, setShowPlusModal] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [numNotification, setNumNotification] = useState(0);
  const [showChangeCurrencyPopup, setShowChangeCurrencyPopup] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(
    user?.selectedCurrency || "EUR"
  );

  const [typeDelete, setTypeDelete] = useState("");
  const [fatherLocationModal,setFatherLocationModal] = useState()
  const [deleteChats, setDeleteChats] = useState(false);
  const [showColorPicker, setShowColorPicker] = useState(null);
  const [showOptions, setShowOptions] = useState(false);
  const [showTokenModal, setShowTokenModal] = useState(false);

  const [typeContentAutomate, setTypeContentAutomate] = useState("");

  const buttonRef = useRef(null);
  const popupRef = useRef(null);
  const [coords, setCoords] = useState({ top: 0, left: 0, width: 0 });



  useEffect(() => {
    // alert('edrefuj')
    if (showAutomation) {
      openModalAutomate(true)
      // dispatch(setShowModal('automate'))
    }
  }, [showAutomation])

  useEffect(() => {
    typeContentAutomateSlice && setTypeContentAutomate(typeContentAutomateSlice)
    selectedAutomationDataSlice && setSelectedAutomationData(selectedAutomationDataSlice)
  },[ typeContentAutomateSlice, selectedAutomationDataSlice,])

  useEffect(() => {
    roleAutomateSlice && setRoleAutomate(roleAutomateSlice)
  },[ roleAutomateSlice])

  useEffect(() => {
    selectedAutomateToDeleteSlice && setSelectedAutomateToDelete(selectedAutomateToDeleteSlice)
  },[ selectedAutomateToDeleteSlice])

  useLayoutEffect(() => {
    // if (isOpen && buttonRef.current) {
    if (showModal == 'floatingMenu' && buttonRef.current) {

      const rect = buttonRef.current.getBoundingClientRect();
      setCoords({ top: rect.bottom, left: rect.left, width: rect.width, right: rect.right });
    }
  }, [showModal, isOpen]);

  const handleCloseNewClient = () => {
    setHideAutomate(false);
    console.log('cerrando')
    window.history.pushState({}, "", `${window.location.pathname}`);

    setTimeout(() => {
      setTypeContentAutomate(false);
      setIsAnimating(false);
    }, 300);
    navigate({
      pathname: location.pathname,
      search: '',
    }, { replace: true });
  };
  const handleCloseSetting = () => {
    setIsAnimating(true);
    setTimeout(() => {
      // setShowSidebar(false); // This line was removed as per the new_code
      setIsAnimating(false);
    }, 300);
  };
  const [clickCount, setClickCount] = useState(0);
  const [clickTimer, setClickTimer] = useState(null);

  const handleProfileClick = () => {
    setClickCount((prev) => prev + 1);

    if (clickTimer) {
      clearTimeout(clickTimer);
    }

    const timer = setTimeout(() => {
      if (clickCount === 0) {
        setShowOptions(true);
      } else {
        navigate("/admin/home");
      }
      setClickCount(0);
    }, 300);

    setClickTimer(timer);
  };

  const handleClickRole = (e) => {
    e.stopPropagation();

    if (user.role == "superadmin" || user.role == "admin") {
      navigate("/admin/accounts");
    } else {
      navigate("/admin/home");
    }
  };


  const openModalAutomate = () => {
    // setIsModalAutomate(true);
    // setIsOpen(false);
    navigate('/admin/workflow')
    dispatch(setShowModal('automate'))
  };

  const closeModalAutomate = () => {
    console.log("closeModalAutomate");

    setTypeContentAutomate("");
    setIsModalAutomate(false);
    // dispatch(setShowModal(false))
  };
  const [configuration, setConfiguration] = useState({
    type: "Gmail",
    folderLocation: "/Inicio/",
    includeAllRemitents: true,
    subjectExactMatch: true,
    bodyExactMatch: true,
    attachmentExactMatch: true,
    selectedTypes: [],
    addedRemitents: [],
    subjectKeyWords: [],
    bodyKeyWords: [],
    emailConnectionData: [],
    selectedEmailConnection: "",
    fileName: "",
    tags: "",
    notificateAfterExport: false,
    notificateGmail: false,
    notificateWhatsApp: false,
    gmailTo: "",
    gmailSubject: "",
    gmailBody: "",
    whatsAppToNotificate: "",
    whatsAppMessage: "",
    totalAmount: {
      currency: "USD",
      min: 0,
      max: 0,
    },
    labels: {
      name: "",
      conditions: [
        {
          title: "",
          description: "",
        },
      ],
      newCondition: {
        title: "",
        description: "",
      },
      filters: [
        {
          id: Date.now(),
          conditionCurrency: {
            title: "",
            description: "",
          },
          conditionOperator: "CONTAINS",
          conditionValue: "",
          type: "Condition",
        },
      ],
    },
    inputType: true,

    labels: null,
    filesExactMatch: false,
    phoneListNotificate: [],
    showContentSelectInfoToProcess: null,
    showContentImport: null,
    showContentExport: null,
    shotContentNotification: null,
    emailListColab: [],
    showContent: {
      info1: false,
      info2: false,
      info3: false,
      info4: false,
      info5: false,
      info6: false,
      info7: false,
      info8: false,
      info9: true,
    },
    actionFrequency: null,

  })
  useEffect(() => {


    // Actualizar el estado
    setConfiguration((prev) => ({
      ...prev,
      type: typeContentAutomate,
    }));

  
}, [typeContentAutomate])

  const handleShowContentAutomate = (
    type,
    automationData,
    fromSelectedAutomation
  ) => {
    console.log('este es el type a actualizar', type);


    // Usa el `type` directamente en lugar de depender de que se haya actualizado en `configuration`
    if (fromSelectedAutomation) {
      setTypeContentAutomate("");
      setTimeout(() => {
        setTypeContentAutomate(type); // ← Usa el `type` recibido como parámetro
        setSelectedAutomationData(automationData);
      }, 300);
    } else {
      setTypeContentAutomate(type);
      setSelectedAutomationData(automationData);
    }
  };


  const [selectedLocationNew, setSelectedLocationNew] = useState(
    user?.id + "/"
  );
  const [menuOpen, setMenuOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  // const close = () => {
  //   setDeleteChats(false);
  // };

  const [colors, setColors] = useState({
    color1: user?.colorPrimary || "#000000",
    color2: user?.colorSecundary || "#10A37F",
  });

  const [presetColors, setPresetColors] = useState([]);


  const handleSetColor = (key, newColor) => {
    setColors((prevColors) => ({
      ...prevColors,
      [key]: newColor,
    }));
  };
  // const [showCorporativeModal, setShowCorporativeModal] = useState(false);
  const [corporativeTitle, setCorporativeTitle] = useState("");
  const [corporativeMessage, setCorporativeMessage] = useState("");
  const [logout, setLogout] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showAddPayMethodPopup, setShowAddPayMethodPopup] = useState(false);
  useEffect(() => {
    if (logout) {
      localStorage.clear();
      navigate("/login");
    }
  }, [logout]);

  const handleLogOut = () => {

    // setShowCorporativeModal(true);
    dispatch(setShowModal('logout'))
    setCorporativeTitle(t("logout"));
    setCorporativeMessage(t("areYouSureLogout"));
  };


  useEffect(() => {

    if (showNotification.id) {
      setTimeout(function () {
        dispatch(setNotification({}));
      }, 5000);
    }
  }, [showNotification]);

  
  const [existCreateFolder, setExistCreateFolder] = useState(false);


  const [selectedAutomateToDelete, setSelectedAutomateToDelete] =
    useState(null);




  const [voiceChat, setVoiceChat] = useState(false);
  const [finalTranscript, setFinalTranscript] = useState("");
  const [countdownNumber, setCountdownNumber] = useState(null);
  // const [shouldSendTranscript, setShouldSendTranscript] = useState(false);
  const finalTranscriptRef = useRef("");
  const countdownNumberRef = useRef(5);

  const { agentId, chatId } = useParams();
  
  
  useEffect(() => {
    dispatch(
      getAgentById({
        idSelectedAgent: agentId,
        setUserData: setSelectedAgent,
        setlanguage: () => { },
      })
    );


  }, [agentId]);


  const recognitionRef = useRef(null);
  const countdownRef = useRef(null);

  useEffect(() => {
    if (!("webkitSpeechRecognition" in window) && !("SpeechRecognition" in window)) {
      alert("Tu navegador no soporta reconocimiento de voz");
      return;
    }

    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();
    recognition.lang = "es-ES";
    recognition.interimResults = true;
    recognition.continuous = true;

    recognition.onresult = (event) => {
      let interimTranscript = "";
      let final = "";
      for (let i = event.resultIndex; i < event.results.length; ++i) {
        if (event.results[i].isFinal) {
          final += event.results[i][0].transcript;
        } else {
          interimTranscript += event.results[i][0].transcript;
        }
      }
      if (final) {
        setFinalTranscript((prev) => {
          const updated = prev + final;
          finalTranscriptRef.current = updated;
          return updated;
        });

      }

    };

    recognition.onerror = (event) => {
      console.error("Speech recognition error", event.error);
    };

    recognition.onend = () => {
      sendTranscriptIfReady();
    };

    recognitionRef.current = recognition;

    if (selectedAgent?._id) {
      sendTranscriptIfReady()
    }

    return () => {
      recognition.stop();

    };

  }, [selectedAgent]);

  const sendTranscriptIfReady = () => {
    const transcript = finalTranscriptRef.current.trim();
    if (!transcript) {
      return
    }

    if (selectedAgent?._id) {
      navigate(`/admin/chat/${selectedAgent._id}`, {
        state: {
          rowId: transcript,
          selectedAgentState: selectedAgent,
        },
      });
      setFinalTranscript("");
      finalTranscriptRef.current = "";
    } else {
      setShowSelectAgent(true);
    }
  };


  const startCountdown = () => {
    if (countdownRef.current) return;
    setCountdownNumber(5);

    countdownRef.current = setInterval(() => {
      setCountdownNumber((prev) => {
        if (prev === 1) {
          clearInterval(countdownRef.current);
          countdownRef.current = null;
          setCountdownNumber(null);
          stopRecordingAndSend();
          return null;
        }


        return prev - 1;
      });
    }, 1000);

  };



  const stopRecordingAndSend = () => {
    if (voiceChat) {
      recognitionRef.current?.stop();
      setVoiceChat(false);
    }
  };



  const cancelCountdown = () => {
    if (countdownRef.current) {
      clearInterval(countdownRef.current);
      countdownRef.current = null;
    }
    setCountdownNumber(null);
  };
  const handleClick = (e) => {
    e.preventDefault();

    cancelCountdown();

    if (!voiceChat) {
      setFinalTranscript("");
      setVoiceChat(true);
      recognitionRef.current?.start();
    } else {
      stopRecordingAndSend();
    }
  };

  const handleDelete = async () => {
    console.log("handleDelete", selectedAutomateToDelete);
    const res = await dispatch(
      deleteAutomation({
        automationId: selectedAutomateToDelete._id,
        userId: selectedAutomateToDelete.userId,
      })
    );
    console.log("res", res);
    return res;
  };

  const [userData, setUserData] = useState();
  const [initialUserData, setInitialUserData] = useState(null);

  const onToggleTheme = async (theme) => {
    try {
      dispatch(setTheme(theme));
      localStorage.setItem('theme', theme);
      const data = await dispatch(createVariable({ variableData: { type: "theme", title: "theme", description: theme } }));
    } catch (e) {
      console.log("Error setting theme:", e);
    }
  }

  const getTheme = async () => {
    try {
      const colorPrimary = await dispatch(getVariable({ type: "theme" }));
      dispatch(setTheme(colorPrimary?.payload?.data?.[0]?.description || "light"));
    } catch (e) {
      console.log("Error getting theme:", e);
    }
  }

  useEffect(() => {
    if (user) {
      const newUserData = {
        nombre: user?.nombre || "",
        email: user?.email || "",
        profileImage: user?.profileImage || "",
        password: user?.password || "",
        phone: user?.phone || "",
        profileImage: user?.profileImage || "",
        countryCode: user?.countryCode || "+34",
        areaCode: user?.areaCode || "+34",
        country: user?.country || "",
        payMethod: user?.payMethod || [],
        plan: user?.plan || "Free",
        userDomain: user?.userDomain || "",
        corporativeLogos: user?.corporativeLogos || [],
        signatureImages: user?.signatureImages || [],
        selectedSignatureImage: user?.selectedSignatureImage || "",
        selectedCorporativeLogo: user?.selectedCorporativeLogo || "",
        fiscalNumber: user?.fiscalNumber || "",
        currency: user?.currency || "EUR",
        maxAccount: user?.maxAccount || 0,
        typePlan: user?.typePlan || 0,
        lastPayment: user?.lastPayment || 0,
        language: user?.language || "Español",
        selectedCurrency: user?.selectedCurrency || "Español",
        tokenGPT: user?.tokenGPT || "",
        colorPrimary: user?.colorPrimary || colors?.color1,
        colorSecundary: user?.colorSecundary || colors?.color2,
        billingDetails: user?.billingDetails || "",
        speechVoice: user?.speechVoice || "",
        speechLenguage: user?.speechLenguage || ""
      };
      setUserData(newUserData);
      setInitialUserData(newUserData);
      getTheme().then()
    }
  }, [user]);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const profileIconRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        profileIconRef.current &&
        !profileIconRef.current.contains(event.target)
      ) {
        dispatch(setShowModal(false))

        // setIsMenuOpen(false);
      }
    }
    if (showModal == 'profileSetting') {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showModal == 'profileSetting']);

  const menuItems = [
    {
      icon: <DashboardBlackIcon />,
      text: t("dashboard"),
      action: () => {
        navigate("/admin/home");
        // setShowOptions(false); // This line was removed as per the new_code
      },
      shortCut: "Alt + H",

    },
    {
      icon: <SettingBlackIcon />,
      text: t("setting"),
      action: () => {
        dispatch(setShowModal('settings'))
        // setShowOptions(false); // This line was removed as per the new_code
        // setShowSidebar(true); // This line was removed as per the new_code

        let basePath = location.pathname;
        basePath = basePath.replace(/\/settings\/[^\/]+/, "");
        basePath = basePath.replace(/\/$/, "");
        const newPath = `${basePath}/settings/general`;
        navigate(newPath);
      },
      shortCut: "Alt + S",
    },
    
    {
      icon: <GptsBlackIcon />,
      // text: t("bots"),
      text: 'Modo Avión',
      action: () => {
        navigate(`/admin/s`, {
          state: { backgroundLocation: location },
        })
        // setShowOptions(false) // This line was removed as per the new_code
      },
      shortCut: "Alt + B",
    },
    {
      icon: <StarPlus />,
      text: t("upgradePlan"),
      action: () => {
        // setShowOptions(false); // This line was removed as per the new_code
        dispatch(setShowModal('plus'))
        // setShowPlusModal(true);
      },
      className: styles.upgradePlan,
    },
    theme === "dark"
      ? {
        icon: <MdLightMode size={18} />,
        text: t("lightMode"),
        action: () => onToggleTheme("light"),
        shortCut: "Alt + J",
      }
      : {
        icon: <LunaDarkMode size={18} />,
        text: t("darkMode"),
        action: () => onToggleTheme("dark"),
        shortCut: "Alt + J",
      },
    {
      icon: <LogoutBlackIcon style={{ marginLeft: "4px" }} />,
      text: t("LogOut"),
      action: () => {
        handleLogOut()
        // setShowOptions(false) // This line was removed as per the new_code
      },
    },
  ];


  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'Alt') {
            dispatch(setShowModal('profileSetting'))
            // setIsMenuOpen(true);
        return;
      }

      if (e.altKey) {
        switch (e.key.toLowerCase()) {
          case 's':
            e.preventDefault();
            menuItems.find(item => item.shortCut === "Alt + S")?.action();
            // setIsMenuOpen(false);
            dispatch(setShowModal(false))

            break;
          case 'h':
            e.preventDefault();
            menuItems.find(item => item.shortCut === "Alt + H")?.action();
            // setIsMenuOpen(false);
            dispatch(setShowModal(false))

            break;
          case 'o':
            e.preventDefault();
            menuItems.find(item => item.shortCut === "Alt + B")?.action();
            // setIsMenuOpen(false);
            dispatch(setShowModal(false))

            break;
          case 'j':
            e.preventDefault();
            menuItems.find(item => item.shortCut === "Alt + J")?.action();
            // setIsMenuOpen(false);
            dispatch(setShowModal(false))

            break;
        }
      }
    };

    const handleKeyUp = (e) => {
      if (e.key === 'Alt') {
        // setIsMenuOpen(false);
            dispatch(setShowModal(false))

      }
    };

    document.addEventListener('keydown', handleKeyPress);
    document.addEventListener('keyup', handleKeyUp);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, []);

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'Control') {
        console.log('Control')
        setIsOpen(true);
        // dispatch(setShowModal('marketplace'))
        return;
      }
    };

    const handleKeyUp = (e) => {
      if (e.key === 'Control') {
        setIsOpen(false);
        // dispatch(setShowModal(false))
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    document.addEventListener('keyup', handleKeyUp);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, []);


  const [isOpenNews, setIsOpenNews] = useState(false);

  // Add search state
  const [searchTerm, setSearchTerm] = useState("");
  const [isFocus, setIsFocus] = useState(false);
  // Create filtered menu options based on search term
  const filteredMenuOptions = menuOptions.filter((item) => {
    if (!searchTerm.trim()) return true;

    const searchLower = searchTerm.toLowerCase();
    return (
      item.title.toLowerCase().includes(searchLower) ||
      item.description.toLowerCase().includes(searchLower)
    );
  });

  useEffect(() => {
    if(selectedCurrency != user?.selectedCurrency){
               setUserData((prev) => ({
                      ...prev,
                      selectedCurrency: selectedCurrency,
                    }));

                     dispatch(updateAccount({
                      data: {
                        ...userData,
                        selectedCurrency: selectedCurrency,
                      },
                    }));
                  }
  },[selectedCurrency])


  return (
    <>
      {isOpenNews && (
        <div className={styles.NavbarNews}>
          <NavbarNews />
          <div 
          className={styles.close} 
          onClick={() => setIsOpenNews(false)}
          >
            <IconClose />
          </div>
        </div>
      )}

      <div className={`${styles.navbarAdmin}`}>
        <div
          className={`${styles.loading} ${isLoading ? styles.active : ""}`}
        />
        <div className={styles.navbarAdminIcons}>
          <a className={styles.noTooltip} href={user ? "/admin/chat" : "/"}>

            {user?.methodPlan ? (
              <div className={styles.name}>
                <FacturaGPTSVG />
                {variant == 'Factura' ? variant : variant?.slice(0, -3) || 'Factura'}
                <span><strong>Gpt</strong></span>
              </div>
            ) : (
              <div className={styles.workspaceContainer}>
                <div>
                  <IconWorkspace />
                </div>
                <b>
                  Workspace 1
                </b>
                <IconStar />
              </div>
            )}

          </a>
          <div
            onClick={() => setMenuOpen(true)}
            className={styles.MenuMobileIcon}
          >
            <MenuMobileIcon />
          </div>
        </div>
       
        <div className={styles.NavarSearchExpand}>
          <div className={`${styles.NavarSearchExpandInput} ${isFocus ? styles.isFocus : ''}`}>
            <IconSearch />
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => {setSearchTerm(e.target.value)
                dispatch(setGlobalSearch(e.target.value))
              }}
              placeholder={`Buscar documentos, contactos, activos y otras tablas`} 
              onFocus={() => setIsFocus(true)}
              onBlur={() => setIsFocus(false)}
              />
            <div>
              /
            </div>
          </div>
          {searchTerm.length > 0 && (
            <div className={styles.NavarSearchExpandList}>
              <ul>
                {filteredMenuOptions.length > 0 ? (
                  filteredMenuOptions.map((item, index) => (
                    <li
                      key={index}
                      className={styles.NavarSearchExpandItem}
                    >
                      <div className={styles.NavarSearchExpandItemContent}>
                        <div className={styles.NavarSearchExpandItemIcon}>
                          {item.icon}
                        </div>
                        <div className={styles.NavarSearchExpandItemContentText}>
                          <b className={styles.NavarSearchExpandItemContentTextTitle}>
                            {item.title}
                          </b>
                          <p className={styles.NavarSearchExpandItemContentTextDescription}>
                            {item.description}
                          </p>
                        </div>
                      </div>
                    </li>
                  ))
                ) : (
                  <li className={styles.NavarSearchExpandItem}>
                    <div className={styles.NavarSearchExpandItemContent}>
                      <div className={styles.NavarSearchExpandItemContentText}>
                        <p className={styles.NavarSearchExpandItemContentTextDescription}>
                          No se han encontrado coincidencias
                        </p>
                      </div>
                    </div>
                  </li>
                )}
              </ul>
            </div>
          )}
        </div>

        {user?.payMethod?.length == 0 ? (
          <div className={styles.hiddenTablet}>
            <button
              onClick={() => setShowPlusModal(true)}
              className={styles.plus}
            >
              {t("buttonGetPlus")} <Star />
            </button>
          </div>
        ) : (
          <></>
        )}

        <div className={styles.hiddenMobile}>
          <div className={styles.profile}>

            <a
              ref={buttonRef}
              data-tooltip={t("deployOptions")}
              // onClick={() => setIsOpen((prev) => !prev)}
              onClick={() => dispatch(setShowModal('floatingMenu'))}
              className={`${styles.addIcon} ${isOpen ? styles.active : ""}`}
              style={{ marginBottom: "3px" }}
            >
              <AddPlus />
            </a>

            <a
              onClick={() => {
                setFromPath("news");
              }}
              className={fromPath.includes("news") ? styles.active : ""}
              data-tooltip={t("news")}
            >
              <IconNews />
            </a>
            <a
              onClick={() => {
                setFromPath("chat");
                navigate({
                  pathname: location.pathname,
                  search: "?open=true"
                });
              }}
              className={fromPath.includes("chat") ? styles.active : ""}
              data-tooltip={t("chat")}
            >
              <ChatIcon />
            </a>
            <a
              href="#!"
              onClick={handleClick}

              onMouseLeave={() => {
                if (voiceChat) startCountdown();
              }}
              onMouseEnter={cancelCountdown}
              className={voiceChat ? "active" : ""}
              data-tooltip="Voice Chat"
              style={{ cursor: "pointer" }}
            >
              <AudioWaves isRecording={voiceChat} setIsRecording={setVoiceChat} />
              {countdownNumber && <span className={styles.notificationTotal}>{countdownNumber}</span>}
            </a>
            {/* <a
              data-tooltip={t("contacts")}
              onClick={() => {
                navigate({
      pathname: location.pathname,
      search: "",
    }, { replace: true }); 
                setFromPath("contacts");
                

              }}
              className={fromPath?.startsWith("contacts") ? styles.active : ""}
            >
              {unseenCountContact > 0 && <span className={styles.notificationTotal}>{unseenCountContact >= 100 ? '+99' : unseenCountContact}</span>}
              <ClientIcon />
            </a> */}
            {/* <a
              data-tooltip={t("assets")}
              onClick={() => {
                navigate({
      pathname: location.pathname,
      search: "",
    }, { replace: true }); 

                setFromPath("assets");
                
              }}
              className={fromPath == "assets" ? styles.active : ""}
              >
              {unseenCountAsset > 0 && <span className={styles.notificationTotal}>{unseenCountAsset >= 100 ? '+99' : unseenCountAsset}</span>}
              <BoxIcon />
            </a> */}
            <a
              data-tooltip={t("notifications")}
              className={`${styles.number} 
                ${fromPath == "notification" ? styles.active : ""}`}
              onClick={() => {
                navigate({
                  pathname: location.pathname,
                  search: "",
                }, { replace: true });
                // setFromPath("notification");
                setFromPath("calendar/schedule");
              }}
              
            >
              <DotsNotification />
              {/* <CalendarIcon /> */}
              {numNotification !== 0 && <span>{numNotification}</span>}
              {unseenCount > 0 && <span className={styles.notificationTotal}>{unseenCount >= 100 ? '+99' : unseenCount}</span>}
            </a>

            <div
              ref={profileIconRef}
              onClick={() => {
            dispatch(setShowModal('profileSetting'))

              }}
              className={styles.profileContainer}
            >
              <div className={styles.profileText}>

                {user?.nombre?.length >= 23 && <p className={styles.pWithTooltip} data-tooltip={user?.nombre}>{`${user?.nombre.slice(0, 22)}..`}</p>}

                {user?.nombre?.length <= 22 && <p>{user?.nombre || t("noFound")}</p>}
                <span onClick={(e) => handleClickRole(e)}>
                  {(user?.role === "superadmin" && isWorkBackend) && (
                    <>
                      👑
                    </>
                  )}

                  {user?.role || t("noFound")}
                </span>
              </div>

              <div className={`${styles.profileImageOff} ${true ? styles.active : ''}`}>
                {user?.profileImage && !imageError ? (
                  <img
                    className={styles.profileImage}
                    src={user.profileImage}
                    onError={() => setImageError(true)}
                  />
                ) : (
                  <div className={styles.initials}>
                    {user?.nombre?.split(" ").map((word) => word[0] || "U").slice(0, 2)}

                    {elapsedTime > 0 && location.pathname !== '/admin/home' && (
                      <span className={`${styles.timeHour} ${isPlaying ? styles.playing : styles.paused}`}>
                        {formatTime(elapsedTime)}
                      </span>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          {showModal == 'profileSetting' && (
            <div ref={menuRef} className={styles.options}>
              <ul>
                {menuItems.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      item.action();
                      // setIsMenuOpen(false);
            dispatch(setShowModal(false))

                    }}
                    className={item.className || ""}
                  >
                    {item.icon} {item.text}
                    {item.shortCut && <span className={styles.shortcut}>{item.shortCut}</span>}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>

      {/* {showSidebar && ( */}
      {showModal == 'settings' && (
        <ModalBlackBgTemplate
          close={() => {
            // setShowSidebar(false);
            dispatch(setShowModal(false))
            const path = location.pathname;

            const cleanedPath = path.replace(/\/settings\/[^\/]+$/, "");

            navigate(cleanedPath);
          }}
          customStyle={{
            maxWidth: "700px",
            width: "100vw",
            height: "80vh",
            minHeight: "80vh",
          }}
        >
          <div className={`${styles.sidebar}`}>
            <GeneralSettings
              // showSidebar={showSidebar}
              // setShowSidebar={setShowSidebar}
              setShowSidebar={() => dispatch(setShowModal(false))}
              setDeleteChats={setDeleteChats}
              setShowColorPicker={setShowColorPicker}
              colors={colors}
              // openModalAutomate={openModalAutomate}
              setSeeBill={setSeeBill}
              setTypeDelete={setTypeDelete}
              setShowTokenModal={setShowTokenModal}
              setShowAddPayMethodPopup={setShowAddPayMethodPopup}
              currentSetting={currentSetting}
              setEditingCurrency={setEditingCurrency}
              editingCurrency={editingCurrency}
              selectedCurrency={userData?.selectedCurrency || "EUR"}
              setSelectedCurrency={setSelectedCurrency}
              initialUserData={initialUserData}
              setInitialUserData={setInitialUserData}
              setUserData={setUserData}
              userData={userData}
              maxAccount={userData?.maxAccount}
              setShowWorkspace={setShowWorkspace}
              setShowInviteToWorkspace={setShowInviteToWorkspace}
              showWorkspace={showWorkspace}
              configuration={configuration}
              setConfiguration={setConfiguration}
            />
          </div>
        </ModalBlackBgTemplate>
      )}

      {showWorkspace && (
        <NewWorkspace
          setShowWorkspace={setShowWorkspace}
          setShowInviteToWorkspace={setShowInviteToWorkspace}
        />
      )}

      {showInviteToWorkspace && (
        <InviteToWorkspace
          setShowInviteToWorkspace={setShowInviteToWorkspace}
          setUserToInvite={setUserToInvite}
          userToInvite={userToInvite}
          setShowMergePlan={setShowMergePlan}
        />
      )}

      {showMergePlan && (
        <ConfirmationWithPasswordPopup
          setState={setShowMergePlan}
          confirmatedPassword={checkMergedPlan}
          titlePopup={t("mergePlan")}
          descPopup={t("mergePlanDesc")}
          acceptBtn={
            <>
              {t('mergePlan')}
            </>}
        />
      )}

      {showAddPayMethodPopup && (
        <AddPaymethodPopup
          setShowAddPayMethodPopup={setShowAddPayMethodPopup}
        />
      )}

      {showTokenModal && (
        <ModalBlackBgTemplate
          close={() => setShowTokenModal(false)}
          customStyle={{
            maxWidth: "50%",
            minHeight: "60%",
          }}
        >
          <TokenModal setShowTokenModal={setShowTokenModal} />
        </ModalBlackBgTemplate>
      )}



      <MobileAsidebarNavigation
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        fromPath={fromPath}
        setFromPath={setFromPath}
        setShowPlusModal={setShowPlusModal}
        setIsOpen={setIsOpen}
        setShowOptions={setShowOptions}
        setShowSidebar={setShowSidebar}
      />

      {/* {showPlusModal && ( */}
      {showModal == 'plus' && (
        <UpgradePlanWrapper
          onClose={() => dispatch(setShowModal(false))}
          setShowSelectCurrencyPopup={setEditingCurrency}
          setSelectedCurrency={setSelectedCurrency}
          selectedCurrency={selectedCurrency}
          setSeeHistory={setSeeHistory}
          seeHistory={seeHistory}
          isAnimating={isAnimating}
          setIsAnimating={setIsAnimating}
        />
      )}

      <NewUserInformation />

      {/* {showCorporativeModal && ( */}
      {showModal == 'logout' && (
        <CorporativeModalText
          title={corporativeTitle}
          message={corporativeMessage}
          // setState={setShowCorporativeModal}
          setState={() => dispatch(setShowModal(false))}
          action={true}
          setAction={setLogout}
          father={"logout"}
        />
      )}

      {/* {deleteChats && ( */}
      {showModal == 'deleteChats' && (
        <DeleteChatAgents
          user={user}
          variant={paramModal.variant}
          // setDeleteChats={setDeleteChats}
          type={paramModal.type}
          selectedOption={paramModal.selectedOption}
        // chats={paramModal.chats}
        // variant={paramModal.type}
        // setVariant={paramModal.variant}
        />
      )}

      {/* {showColorPicker && ( */}
      {showModal == 'colorPicker' && (
        <ColorPicker
          setShowColorPicker={() =>{ setShowColorPicker(null)
            dispatch(setShowModal('settings'))
          }}
          color={colors[showColorPicker]}
          setColor={(newColor) => handleSetColor(showColorPicker, newColor)}
          presetColors={presetColors}
          setPresetColors={setPresetColors}
        />
      )}

      {/* {seeHistory && ( */}
      {showModal == 'seeHistory' && (
        <div className={styles.seeHistoryContainer}>
          <SeeHistory
            setSeeHistory={setSeeHistory}
            seeHistory={seeHistory}
            isAnimating={isAnimating}
            setIsAnimating={setIsAnimating}
          />
        </div>
      )}

      {/* {showChangeCurrencyPopup && ( */}
      {showModal == 'changeCurrency' && (
        <SelectCurrencyPopup
          setShowSelectCurrencyPopup={() => dispatch(setShowModal(false))}
          setSelectedCurrency={setSelectedCurrency}
          selectedCurrency={selectedCurrency}
        />
      )}

      {/* {editingCurrency && ( */}
      {showModal == 'changeCurrency' && (
        <>
          <div
            className={styles.bgCurrency}
            onClick={() => dispatch(setShowModal(false))}
          />
          <div className={styles.newCurrencyPopup}>
            {currenciesOptions.map((currency, subIndex) => {
              const subOption = `${currency.name} (${currency.code}) - ${currency.symbol}`;
              return (
                <div
                  key={subIndex}
                  className={styles.dropdownOption}
                  onClick={async () => {
                    const newCurrency = currency.code;

                    setUserData((prev) => ({
                      ...prev,
                      selectedCurrency: newCurrency,
                    }));

                    await dispatch(updateAccount({
                      data: {
                        ...userData,
                        selectedCurrency: newCurrency,
                      },
                    }));
                  }}

                >
                  {subOption}
                  {userData.selectedCurrency === currency.code && (
                    <BlackCircleChecked />
                  )}
                </div>
              );
            })}
          </div>
        </>
      )}

      {/* {isOpen && ( */}
      {(showModal == 'floatingMenu') && (
        <FloatingMenu
          customStyle={{
            positioin: "absolute",
            top: "0px",
            right: `-${coords.right + coords.width}px`,
            transform: 'translateX(-50%)'
          }}
          ref={popupRef}
          // isOpen={isOpen}
          setIsOpen={() => {
            setIsOpen(false)
            dispatch(setShowModal(false))
          }}
          openModalAutomate={openModalAutomate}
          // closeModalAutomate={closeModalAutomate}
          showCreateFolder={showCreateFolder}
          setShowCreateFolder={setShowCreateFolder}
          showNewTagModal={showNewTagModal}
          setShowNewTagModal={setShowNewTagModal}
          showNewContact={showNewContact}
          setShowNewContact={setShowNewContact}
          showNewProduct={showNewProduct}
          setShowNewProduct={setShowNewProduct}
          setShowNewBill={setShowNewBill}
          setShowLocationModal={setShowLocationModal}
          setExistCreateFolder={setExistCreateFolder}
        />
      )}


      {/* {showDeletePopup && ( */}
      {showModal == 'deleteAutomate' && (
        <ConfirmationPopup
          onClose={() => setShowDeletePopup(false)}
          message={t("wantToDeleteAutomation")}
          titleMessage={t("deleteAutomation")}
          handleAccept={handleDelete}
          customStyles={{
            minHeight: "200px",
          }}
          customStylesMessage={{
            textAlign: "center",
          }}
          handleCloseNewClient={handleCloseNewClient}
          openModalAutomate={openModalAutomate}
        />
      )}

      {/* {showNewTagModal && ( */}
      {showModal == 'newTag' && (
        <NewTag setShowNewTagModal={setShowNewTagModal} />
      )}

      {/* {showCreateFolder && ( */}
      {showModal == 'createFolder' && (
        <CreateFolderModal
          // onClose={() => setShowCreateFolder(false)}
          onClose={() => dispatch(setShowModal(false))}
          location={selectedLocationNew}
          setShowLocationModal={setShowLocationModal}
          setSelectedLocationNew={setSelectedLocationNew}
          existCreateFolder={existCreateFolder}
          setFatherLocationModal={setFatherLocationModal}
        />
      )}

      {/* {showLocationModal && ( */}
      {showModal == 'location' && (
        <SelectLocation
          // onClose={() => setShowLocationModal(false)}
          onClose={() => dispatch(setShowModal(false))}
          setSelectedLocationNew={setSelectedLocationNew}
          selectedLocationNew={selectedLocationNew}
          showNewFolder={false}
          setIsLoading={setIsLoading}
          existCreateFolder={existCreateFolder}
          setFatherLocationModal={setFatherLocationModal}
          fatherLocationModal={fatherLocationModal}
        />
      )}


      {/* {isModalAutomate && ( */}
      {/* {showModal == 'automate' && (
        <Automate
          typeContent={handleShowContentAutomate}
          // close={closeModalAutomate}
          close={() => dispatch(setShowModal(false))}
          isModalAutomate={isModalAutomate}
          setIsModalAutomate={setIsModalAutomate}
          isAnimating={isAnimating}
          setIsAnimating={setIsAnimating}
          type={typeContentAutomate}
          // showDeletePopup={showDeletePopup}
          showDeletePopup={() => dispatch(setShowModal('deleteAutomate'))}
          setShowDeletePopup={setShowDeletePopup}
          setSelectedAutomateToDelete={setSelectedAutomateToDelete}
          search={searchAutomate}
          setHideAutomate={setHideAutomate}
          hideAutomate={hideAutomate}
          setRoleAutomate={setRoleAutomate}
        />
      )} */}


      {/* {showModal == 'automate' && ( */}
      {typeContentAutomate && (
        <PanelAutomate
          automationData={selectedAutomationData}
          typeContent={handleShowContentAutomate}
          setIsModalAutomate={setIsModalAutomate}
          close={handleCloseNewClient}
          type={typeContentAutomate}
          isAnimating={isAnimating}
          selectedAgent={selectedAgent}
          setSelectedAgent={setSelectedAgent}
          showSelectAgent={showSelectAgent}
          setShowSelectAgent={setShowSelectAgent}
          typeVariableModal={typeVariableModal}
          setTypeVariableModal={setTypeVariableModal}
          showVariableListModal={showVariableListModal}
          setShowVariableListModal={setShowVariableListModal}
          showVariableModal={showVariableModal}
          setShowVariableModal={setShowVariableModal}
          setHideAutomate={setHideAutomate}
          setShowModal={setShowModal}
          configuration={configuration}
          setConfiguration={setConfiguration}
          setRoleAutomate={setRoleAutomate}
          roleAutomate={roleAutomate}

          setTypeContentAutomate={setTypeContentAutomate}
          setIsAnimating={setIsAnimating}
          // setQuestion={setQuestion}
          // question={question}
        />
      )}

      {/* {seeBill && ( */}
      {showModal == 'seeBill' && (
        <SeeBill
          setSeeBill={() => dispatch(setShowModal(false))}
        />
      )}

      {/* {showNewContact && ( */}
      {showModal == 'newContact' && (
        <NewContact
          // setShowNewContact={setShowNewContact}
          setShowNewContact={() => dispatch(setShowModal(false))}
          newContactProp={showNewContact}
        />
      )}

      {/* {showNewProduct && ( */}
      {showModal == 'newAsset' && (
        <NewAsset
          // setShowNewAsset={setShowNewProduct}
          setShowNewAsset={() => dispatch(setShowModal(false))}
          showNewProduct={showNewProduct}
          setShowNewContact={setShowNewContact}
          showNewContact={showNewContact}
        />
      )}

      {/* {showNewBill && ( */}
      {showModal == 'newBill' && (
        <NewBIll
          // setShowNewBill={setShowNewBill} 
          setShowNewBill={() => dispatch(setShowModal(false))}
        />
      )}

      {/* {showSelectAgent && ( */}
      {showModal == 'selectAgent' && (
        <SelectAgentModal
          close={() => dispatch(setShowModal(false))}
          setState={() => dispatch(setShowModal(false))}
        // setSelectedAgent={setSelectedAgent}
        // question={question}
        />
      )}

      {/* {showVariableModal && ( */}
      {showVariableModal && (
        <VariableModal
          setShowVariableModal={setShowVariableModal}
          VariableModal={showVariableModal}
          type={typeVariableModal}
          fromAutomateOut={"SelectCategoryAndConcept"}
        />
      )}


      {true && (
        <MessageDoc />
      )}



      {showNotification.id && (
        <Notification />
      )}

      {showModal == 'exploreCommunity' && (
        <ExploreCommuniti
          close={() => dispatch(setShowModal(false))}
        />
      )}
    </>
  );
};

export default NavbarAdmin;


